<template>
    <li class="layer" :class="{ selected }">
        <div class="row" :class="children ? 'haschildren' : 'hasnochildren'">
            <button v-if="children" class="caret" :class="{ rotated: isOpen }" title="Toggle" @click.stop="toggle">▾</button>
            <span class="thumb text">T</span>
            <span class="label">Text Layer</span>
            <span class="meta">"Title"</span>
        </div>
    </li>
</template>

<script>
export default {
    name: 'TextComp',
    props: {
        selected: {
            type: Boolean,
            required: true
        },
        children: {
            type: Array,
            required: false
        }
    }
}
</script>

<style scoped>
.layer .row { display: grid; align-items: center; gap: 8px; padding: 6px 8px; border: 1px solid var(--border); background: var(--panel); border-radius: 6px; }
.haschildren { grid-template-columns: 16px 20px 1fr auto; }
.hasnochildren { grid-template-columns: 20px 1fr auto; }
.layer.group .row { background: var(--panel-2); }
.layer.selected .row { border-color: var(--accent, #5b8cff); background: var(--panel-selected); }
.layers { list-style: none; margin: 0; padding: 0; display: grid; gap: 4px; }
.layer { border-radius: 6px; }
.caret { width: 16px; text-align: center; color: var(--muted); transition: transform 160ms ease; display: inline-block; background: transparent; border: 0; padding: 0; cursor: pointer; font: inherit; }
.caret.rotated { transform: rotate(-90deg); }
.caret.placeholder { color: transparent; }
.thumb { width: 20px; height: 20px; border-radius: 4px; display: inline-flex; align-items: center; justify-content: center; font-size: 11px; color: var(--muted); border: 1px solid var(--border); background: var(--panel-2, #1c2738); }
.thumb.board { border-style: dashed; }
.thumb.color { border: 1px solid var(--border); background: #ffffff; }
.thumb.text { font-weight: 700; }
.label { color: var(--text); font-size: 12px; }
.meta { color: var(--muted); font-size: 11px; }
.children { list-style: none; margin: 4px 0 0 20px; padding: 0; display: grid; gap: 4px; }
</style>
